<template>
  <div class="container">
    <ul class="step-list">
      <li v-for="(item, index) in listData" :key="index">
        <div class="step-item" :class="item.state === '1' ? 'step-success' : item.state === '2' ? 'step-primary' : ''">
          <div class="circle" :style="{ 'background': item.state === '1' || item.state === '2' ? '#427AF4' : '#EAEBEE' }">
          </div>
          <div class="step-item-head">
            <div class="title">{{ item.title }}</div>

            <div class="state">
              <span v-if="item.state === '1'">
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 8 8" fill="none">
                  <circle cx="4" cy="4" r="4" fill="#27AD5D" />
                </svg>
                已办结
              </span>
              <span v-if="item.state === '2'">
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 8 8" fill="none">
                  <circle cx="4" cy="4" r="4" fill="#27AD5D" />
                </svg> 办理中
              </span>
              <span v-if="item.state === '0'">
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 8 8" fill="none">
                  <circle cx="4" cy="4" r="4" fill="#FDA804" />
                </svg> 未办理
              </span>
            </div>
          </div>
          <div class="step-item-body">
            <van-cell :class="child.state1 === '1' ? 'bg-success' : child.state1 === '2' ? 'bg-primary' : ''"
              :border="false" :is-link="false" v-for="(child, index) in item.subList" :key="index" :title="child.title"></van-cell>
          </div>
        </div>
      </li>
    </ul>
    <el-empty v-if="listData.length === 0" description="暂无数据"></el-empty>
  </div>
</template>
<script>
import {getBusinessInfoByProjectId}  from '@/api/interface/project.js';
export default {
  name: 'schedule',
  data() {
    return {
      listData: [],
      code: '',
      data: {},
      code:null
    }
  },
  created(){
    
    try {
      const href = location.href
      this.code = new Map()
      if (href.includes('?')) href.split('?')[1].split('&').forEach(item => {
        const temp = item.split('=')
        this.code.set(temp[0], temp[1].split('#')[0])
      });
    } catch (err) {
      console.log(err);
    }
  },
  mounted() {
    
    const projectDetail = getBusinessInfoByProjectId({ 
      projectId: this.code.get('projectCode'),
      page:1,
      rows:1000
     })
    this.listData=[]
    projectDetail
      .then((result) => {
        const data = result.data.itemData
        data.forEach(item => {
          this.listData.push({
            title: item.stageName,
            state: '',
            subList: item.itemInfo.map(item => {
              return {
                title: item.ITEM_NAME
              }
            })
          })
        })
        if (this.listData.some(item => item.subList.length == 0)) {
          for (let i = 0; i < this.listData.length; i++) {
            if (this.listData[i].subList.length==0) {
              for (let j = 0; j < i; j++) {
                this.listData[j].state = '1'
                if ((i - j) == 1) this.listData[j].state = '2'
              }
              for (let j = i; j < this.listData.length; j++) {
                this.listData[j].state = '0'
              }
              break
            }
          }
        } else {
          this.listData.forEach(item => {
            item.state = '1'
          });
        }
      }).catch((err) => {
        console.log(err);
      });
  }
}
</script>
<style lang="less" scoped>
.container{
  padding: 0px 8px;
}

.step-list {
  margin-top: 20px;
  font-size: 16px;
  >li {
    padding-bottom: 20px;
    padding-left: 20px;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 1px;
      background: #eaebee;
      top: 0;
      bottom: 0;
      left: 0;
    }

    &:first-child {
      &:before {
        top: 10px;
      }
    }

    &:last-child {
      &:before {
        bottom: 35px;
        // display: none;
      }
    }
  }

  .step-item {
    position: relative;

    .circle {
      height: 9px;
      width: 9px;
      border: 1px solid #fff;
      background: #eaebee;
      position: absolute;
      top: 10px;
      left: -24px;
      border-radius: 50%;
    }

    .step-item-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 12px;
      background: linear-gradient(90deg,
          rgba(219, 219, 219, 0.3) 0%,
          rgba(242, 242, 242, 0.3) 100%);

      span {
        display: flex;
        align-items: center;

        svg {
          margin-right: 5px;
        }
      }
    }

    .step-item-body {
      .van-cell {
        background: transparent;
        padding-top: 0 !important;
        padding-bottom: 0px !important;
        font-weight: normal;
        margin-top: 14px;
      }

      .bg-success {
        background: linear-gradient(90deg,
            rgba(44, 174, 97, 0.3) 0%,
            rgba(237, 248, 241, 0.3) 100%);
      }

      .bg-primary {
        background: linear-gradient(90deg,
            rgba(66, 122, 244, 0.3) 0%,
            rgba(237, 242, 248, 0.3) 100%);
      }
    }

    &.step-success {
      background: linear-gradient(180deg,
          rgba(44, 174, 97, 0.05) 13.97%,
          rgba(255, 255, 255, 0.05) 100%);

      // rgba(44, 174, 97, 1), rgba(255, 255, 255, 1)
      .step-item-head {
        background: linear-gradient(90deg,
            rgba(44, 174, 97, 0.3) 0%,
            rgba(237, 248, 241, 0.3) 100%);
      }
    }

    &.step-primary {
      .step-item-head {
        background: linear-gradient(90deg,
            rgba(66, 122, 244, 0.3) 0%,
            rgba(237, 242, 248, 0.3) 100%);
      }
    }
  }
}
</style>
